// extracted by mini-css-extract-plugin
export var numberInputContainer = "_74-0";
export var startPickingButton = "_74-1";